<div class="throbber_wrapper">
    <div class="throbber"></div>
</div>
